import React from 'react';
import { Helmet } from "react-helmet";
import { useHistory } from 'react-router-dom';
import { Title, BodyText } from '@minerva-analytics/pantheon';

import {
  ContactUsContainer,
  IconText,
  MailIcon,
  BuildingIcon,
  PhoneIcon,
  SubscribeButton,
  CardContent,
  TinyBodyText,
  Card
} from './ContactUs.styles';

const ContactUs = () => {
  const history = useHistory();

  const navToHome = () => {
    history.push(`/`);
  };

  return (
    <>
      <Helmet>
        <title>Contact Us | The Daily Atom</title>
        <meta
          name="og:title"
          property="og:title"
          content="About Us | Keep It Reel"
        />
        <meta
          name="og:description"
          property="og:description"
          content="Need to get in touch with us? You can find all our contact information right here!"
        />
        <meta
          name="description"
          property="description"
          content="Need to get in touch with us? You can find all our contact information right here!"
        />
      </Helmet>
      <ContactUsContainer>
        <Card>
          <CardContent>
            <Title>Knowledge Is Power!</Title>
            <BodyText>
              Have questions, comments, or suggestions? We&apos;d love to hear them! Send us an email or reach out to us on social media and a team member will get back to you as soon as possible.
            </BodyText>
            <IconText>
              <MailIcon />
              <BodyText><span>help@thedailyatom.com</span></BodyText>
            </IconText>
            <IconText>
              <BuildingIcon />
              <BodyText>
                <span>
                  1770 Massachusetts Ave #268 <br /> Cambridge, MA 02140
                </span>
              </BodyText>
            </IconText>
            <IconText>
              <PhoneIcon />
              <BodyText><span>617-335-3742</span></BodyText>
            </IconText>
            <TinyBodyText>Not subscribed yet?</TinyBodyText>
            <SubscribeButton onClick={navToHome}>
              Sign Up Today for Free
            </SubscribeButton>
          </CardContent>
        </Card>
      </ContactUsContainer>
    </>
  );
};

export default ContactUs;
